import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Scanner from "./scanner";
import { fetchfdTicketList } from "services/redux/maintenance/freshdesk/action";

const mapStateToProps = (state) => ({
    fdTicketLists: state.FreshdeskReducer.fdTicketLists,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        fetchfdTicketList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Scanner);
